
import { PricingResolved } from '@/types/pricing-plan';
import { Component, Vue, Prop } from 'vue-property-decorator';
import { getPlanSubscription, getSubscriptionDuration } from '@/utils/subscriptions';
import { Subscription } from '@/types/subscriptions';
import { DeviceInfo } from '@/types/device-info';
import { getCurrencySymbol } from '@/utils/currency';

@Component({
    components: {},
})
export default class PlanCard extends Vue {
    protected getPlanSubscription = getPlanSubscription;
    protected getCurrencySymbol = getCurrencySymbol;
    protected planSubscription: Subscription | null = null;

    @Prop({ required: true })
    plan!: PricingResolved;

    @Prop({ required: false, default: false })
    selected!: boolean;

    @Prop({ required: false })
    onPurchase!: (plan: PricingResolved) => void;

    @Prop({ required: false })
    onViewDetails!: (plan: PricingResolved) => void;

    @Prop({ required: false, default: [] })
    userSubscriptions!: Subscription[];

    @Prop({ required: false, default: [] })
    device!: DeviceInfo;

    @Prop({ required: true, default: true })
    isUpdateAble!: boolean;

    @Prop({ required: true, default: '' })
    schedulePlanId!: string;

    @Prop({ default: 0 })
    feeChagre!: number;

    get buttonActive() {
        return (
            (!this.isUpdateAble && this.schedulePlanId && this.schedulePlanId == this.plan._id) ||
            this.planSubscription != null
        );
    }

    get buttonText() {
        if (this.planSubscription) return `Subscribed`;
        if (this.schedulePlanId && this.schedulePlanId == this.plan._id) return `Scheduled to subscribe`;
        if (this.plan.freeTrialDays) {
            return `Try for free now with ${
                this.plan.freeTrialDays == 1 ? `a day` : `${this.plan.freeTrialDays} days`
            } trial`;
        }
        return `Activate Now`;
    }

    get planPrice() {
        let amount = this.plan?.price;
        if (this.plan?.taxRate) {
            let taxAmount = (amount / 100) * this.plan?.taxRate.percentage;
            amount += taxAmount;
        }
        return amount.toFixed(2);
    }

    get duration() {
        if (this.plan?.duration === 'days') return `${this.plan?.frequencyDays} days`;
        return getSubscriptionDuration(this.plan?.duration as string);
    }

    get planTax() {
        const currency = getCurrencySymbol(this.plan?.currency ? this.plan?.currency : 'USD');
        let taxAmount = 0;
        if (this.plan?.taxRate) {
            taxAmount = (this.plan?.price / 100) * this.plan?.taxRate.percentage;
            return `${currency}${taxAmount.toFixed(2)}`;
        }
        return 'N/A';
    }

    get extraFeeChagre() {
        const currency = getCurrencySymbol(this.plan?.currency ? this.plan?.currency : 'USD');
        return `${currency}${Number(this.feeChagre).toFixed(2)}`;
    }

    get planTaxInfo() {
        if (this.plan?.taxRate) return `(${this.plan?.taxRate.name} ${this.plan?.taxRate.percentage}%)`;
        return '';
    }

    get planTotal() {
        const currency = getCurrencySymbol(this.plan?.currency ? this.plan?.currency : 'USD');
        let amount = this.plan?.price;
        if (this.plan?.taxRate) {
            let taxAmount = (amount / 100) * this.plan?.taxRate.percentage;
            amount += taxAmount;
        }
        if (this.feeChagre) amount += Number(this.feeChagre);
        return `${currency}${amount.toFixed(2)}`;
    }

    get isActive() {
        return this.plan.mostPopularPlan;
    }

    mounted() {
        this.planSubscription = getPlanSubscription(
            this.userSubscriptions,
            this.plan._id as string,
            this.device.deviceUUID,
        );
        if (this.planSubscription && this.planSubscription.status === 'trialing') {
            this.isUpdateAble = true;
            this.buttonActive;
        }
    }
}
